import {default as qrCode} from '../../common/libs/qrcode.js';

export default (() => {

    const global = {elements: {}};

    function initialise (config) {
        _cachePageData(config);
        _cacheElements();
        _bindEvents();
        _initialiseComponents();
        _bindSignalREvents();
        _initialiseSignalR();
    }

    function _cacheElements () {
        global.elements = {
            animationStep1: document.querySelector('[data-animation-step-1]'),
            progressDiagram: document.querySelector('[data-progress-diagram]'),
            fieldUploads: [...document.querySelectorAll('[data-field-upload-signature]')],
            buttonContinue: document.querySelector('[data-button-continue]'),
            animationStep2: document.querySelector('[data-animation-step-2]'),
            form: document.querySelector('[data-image-upload-form]'),
            formFile: document.querySelector('[data-form-uploaded-file]'),
            qrCodeContainer: document.querySelector('[data-qr-code-container]'),
            qrCodeCopyButton: document.querySelector('[data-copy-qr-code-button]'),
            qrHandoffCard: document.querySelector('[data-qr-handoff'),
            qrHandoffInProgressCard: document.querySelector('[data-qr-handoff-in-progress]'),
            howWorksButton: document.querySelector('[data-how-works-button]'),
            handoffCancelled: document.querySelector('[data-handoff-cancelled]'),
            cancelHandoff: document.querySelector('[data-cancel-handoff]'),
            fileUploadCard: document.querySelector('[data-file-upload-card]')
        };

        if (global.pageData.isTransferHandoffEnabled) {
            global.elements.qrCode = new qrCode(global.elements.qrCodeContainer, {
                text: global.pageData.qrCodeURL,
                height: 200,
                width: 200
            });
        }
    }

    function _cachePageData (config) {
        global.pageData = {...config};
        global.pageData.transferHubProxy = global.pageData.connection.transferHub;
        global.pageData.qrCodeURL = `${window.location.origin}/Transfer/SignatureUploadDevice/${global.pageData.portfolioID}?deviceHandoff=true`;
        global.pageData.isDeviceHandoff = global.pageData.isDeviceHandoff ? wealthify.type.boolean.toBoolean(global.pageData.isDeviceHandoff) : false;
        global.pageData.isDevice = global.pageData.isDevice ? wealthify.type.boolean.toBoolean(global.pageData.isDevice) : false;
    }

    function _bindEvents () {
        global.elements.fieldUploads.forEach(field => {
            field.addEventListener('fileselected', _bindFile);
        });

        global.elements.buttonContinue.addEventListener('click', _transitionPageAndSubmitForm, true);

        if (global.pageData.isTransferHandoffEnabled) {
            global.elements.qrCodeCopyButton.addEventListener('click', _copyLinkAndUpdateButtonState);
        }

        if(global.elements.cancelHandoff){
            global.elements.cancelHandoff.addEventListener('click', () => {
                global.pageData.transferHubProxy.server.handoffCancelled(global.pageData.portfolioID);
            });
        }
    }

    function _bindFile(event){
        global.elements.formFile.files = event.currentTarget.files;
    }

    function _bindSignalREvents(){

        if(!global.pageData.isDevice){
            global.pageData.connection[global.pageData.hubName].client.handoffStarted = function() {
                _updateHandoffUI(true);
            };

            global.pageData.connection[global.pageData.hubName].client.handoffComplete = function() {
                _handoffComplete(true);
            };
        }

        global.pageData.connection[global.pageData.hubName].client.handoffCancelled = _handoffCancelled;

    }

    function _initialiseSignalR(){
        global.pageData.connection.hub.start().done(function (){
            if(global.pageData.isDeviceHandoff && global.pageData.isDevice){
                global.pageData.transferHubProxy.server.handoffStarted(global.pageData.portfolioID);
            }
        });

        if(global.pageData.isDevice){
            global.pageData.connection.hub.disconnected(_updateHandoffUIToCancelled);
        }
    }

    function _handoffCancelled(){
        if(global.pageData.isDevice){
            _updateHandoffUIToCancelled();
        }else{
            _updateHandoffUI(false);
        }
    }

    function _updateHandoffUIToCancelled(){
        global.elements.animationStep1.classList.add('u-display__none');
        global.elements.animationStep2.classList.add('u-display__none');
        global.elements.handoffCancelled.classList.remove('u-display__none');
        // Scroll to top to see handoff cancelled message
        window.scrollTo({top: 0});
    }

    function _updateHandoffUI(handoffInProgress){
        const qrHandoffCardClassAction = handoffInProgress ? 'add' : 'remove';
        const fileUploadCardClassAction = handoffInProgress ? 'add' : 'remove';
        const qrHandoffCardInProgressClassAction = handoffInProgress ? 'remove' : 'add';

        global.elements.qrHandoffCard.classList[qrHandoffCardClassAction]('u-display__none');
        global.elements.fileUploadCard.classList[fileUploadCardClassAction]('u-display__none');
        global.elements.qrHandoffInProgressCard.classList[qrHandoffCardInProgressClassAction]('u-display__none');
        global.elements.howWorksButton.disabledProp = handoffInProgress;
    }

    function _handoffComplete() {
        window.location.href = `${window.location.origin}/Transfer/EditSignature/${global.pageData.portfolioID}`;
    }

    function _initialiseComponents () {
        // remove inline style that hides the spinner before the utility classes load,
        // once loaded no longer required.
        global.elements.animationStep2.style.removeProperty('display');

        if(global.elements.progressDiagram){
            global.elements.progressDiagram.steps = [{
                'icon': 'pencil',
                'titleprop': 'You sign your name',
                'description': 'Any piece of blank paper will work as long as you use a black or blue pen.'
            }, {
                'icon': 'camera',
                'titleprop': 'Take a picture',
                'description': 'Snap a clear photo of your signature in good lighting and upload it using the button below.'
            }, {
                'icon': 'upload',
                'titleprop': 'Check and upload',
                'description': 'If you\'re happy with your signature, the photo is in focus, and your name is in the centre etc. then simply upload the photo of your signature.'
            }];
        }
    }

    function _transitionPageAndSubmitForm () {
        
        global.elements.fieldUploads.forEach((field) => {
            field.validation.events.ToggleInteractedWith.dispatch();
            field.validation.events.FireValidation.dispatch();
        });
        
        if(global.elements.form.checkValidity()){
            global.elements.animationStep1.classList.add('u-display__none');
            global.elements.animationStep2.classList.remove('u-display__none');
            
            // Scroll to top to see animation.
            window.scrollTo({top: 0});
            
            global.elements.form.submit();
        }
    }

    function _copyLinkAndUpdateButtonState () {
        const defaultIcon = global.elements.qrCodeCopyButton.iconleft;
        const defaultLabel = global.elements.qrCodeCopyButton.label;

        _updateButtonState();
        _copyCodeToClipboard();
        setTimeout(() => {
            _updateButtonState(defaultIcon, defaultLabel);
        }, 3000);
    }

    function _copyCodeToClipboard(){
        navigator.clipboard.writeText(global.pageData.qrCodeURL);
    }

    function _updateButtonState(icon = 'success-outlined', label = 'Copied'){
        global.elements.qrCodeCopyButton.iconleft = icon;
        global.elements.qrCodeCopyButton.label = label;
    }

    return { initialise };
})();